import React, { useState, useRef, useEffect } from 'react';
import styles from './MenuOption.module.scss';
import { Icon } from 'components/common';
import { icons } from 'assets';
import ContextMenu from '../../ContextMenu';
import { MenuOptionProps } from './types';

const MenuOption = (props: MenuOptionProps) => {
  const {
    label,
    shortcut,
    subOptions,
    checkable,
    checked,
    action,
    hide,
    containerHeight,
    containerWidth
  } = props;

  const [showSubOptions, setShowSubOptions] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onMouseEnter = () => {
    // Clear any pending hide timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    // Show submenu immediately
    if (subOptions.length > 0) {
      setShowSubOptions(true);
    }
  };

  const onMouseLeave = () => {
    // Add delay before hiding to allow user to move cursor to submenu
    timeoutRef.current = setTimeout(() => {
      setShowSubOptions(false);
    }, 150);
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const checkedIconStyles = [styles.checkIcon];
  checked && checkedIconStyles.push(styles.checked);

  return (
    <div
      className={styles.container}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={action ? { cursor: 'pointer' } : {}}
      onClick={action}
    >
      {checkable &&
        <Icon
          className={checkedIconStyles.join(' ')}
          icon={icons.checked}
        />
      }
      <p>{label}</p>
      <span>{shortcut}</span>
      {
        !!subOptions.length &&
        <Icon icon={icons.arrowRight} />
      }

      {showSubOptions &&
        <ContextMenu
          options={{ subOptions }}
          leftOffsetRatio={2}
          position={{
            top: 0,
            left: 300
          }}
          hide={hide}
          containerHeight={containerHeight}
          containerWidth={containerWidth}
        />
      }
    </div>
  );
};

export default MenuOption;
